import styled from 'styled-components';

export const BackgrounsWrappper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -2;
    background-color: ${({ theme }) => theme.colors.grey[50]};

    > :nth-child(odd) {
        background-color: ${({ theme }) => theme.colors.grey[200]};
    }
`;

export const Background = styled.div`
    position: relative;
`;
